import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './notification_component.scss';

const NotificationComponent = ({faIcon, textNotification, tipo}) => {
    
    return (
        <div className={`notificationComponent ${tipo}`}>
           
           {
                faIcon === null ? null : 
                <div className={'notificationIcon'}>
                    <FontAwesomeIcon icon={faIcon} />
                </div>
           }
            <div className={'notificationText'}>
                <p className={'notificationP'}>{textNotification}</p>
            </div>
        </div>
    )

}

export default NotificationComponent;








